export default "__VITE_ASSET__1d55fe61__"